module.exports = __webpack_public_path__ + "static/img/damages.f0f6e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/damages.png
// module id = Y3T7
// module chunks = 3